import { useState } from 'react';
import styled, { ThemeProvider } from 'styled-components';
import { closeDropper } from '../../services/dropper';
import { stores, useStore } from '../../utils/store';
import { getTheme, Theme } from '../theme';
import PopoverBody from './PopoverBody';

export default function PopoverController() {
    const [theme,] = useState<Theme>(getTheme);
    const [dropper,] = useStore(stores.UI.dropper);

    if (!dropper) return null;

    return (
        <ThemeProvider theme={theme}>
            <Wrapper onMouseDown={() => closeDropper()}>

            </Wrapper>
            <PopoverBody {...dropper} />
        </ThemeProvider>
    )
}

const Wrapper = styled.div`
    position: fixed;
    top: 0; bottom: 0; left: 0; right: 0;
`